import type { MutableRefObject, RefObject } from 'react';
import { useReducer } from 'react';

import { useViewObserver } from './useViewObserver';

export const useLazyRender = (
  ref: MutableRefObject<HTMLElement> | RefObject<HTMLElement>
) => {
  const [shouldDisplay, onView] = useReducer(() => true, false);

  useViewObserver({
    onView,
    elementRef: ref,
  });

  return { shouldDisplay };
};
